// Grabs the group_number if exits to pass to vendors API to generate plan specific discount card
import { useParams } from "react-router";

import { useGetURLQuery } from "capitalrx-components-2.0";

import { Params } from "@/types/AdvantageCardRequest";
import { QueryParams } from "@/types/QueryParams";
import { useContext } from "react";
import { ThemeSelectorContext } from "@/context";

export const useGroupNumber = (): string | null => {
  const { url_params_group_number }: Params = useParams();
  const { group_number } = useGetURLQuery<QueryParams>(null);
  const { groupNumber } = useContext(ThemeSelectorContext);

  let submittedGroupNumber = group_number || url_params_group_number || groupNumber;

  if (isNaN(Number(submittedGroupNumber))) {
    submittedGroupNumber = "";
  }

  return submittedGroupNumber;
};
